import Axios from "axios";
import {
  AddOfficePostRolesRequest,
  GetRolesByOfficePostIdResponse,
} from "../models/officePostRole.model";
import { ApiResultModel } from "../models/common.model";
import { ApiBaseUrl, OfficePostRole, ReportURL } from "../config/config";

export const GetRolesByOfficePostId = async (data: {
  officePostId: number;
}): Promise<GetRolesByOfficePostIdResponse[]> => {
  return await Axios.post<ApiResultModel<GetRolesByOfficePostIdResponse[]>>(
    ApiBaseUrl + OfficePostRole + "/GetRolesByOfficePostId",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const AddOfficePostRoles = async (
  data: AddOfficePostRolesRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + OfficePostRole + "/AddOfficePostRoles",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteOfficePostRoles = async (
  data: AddOfficePostRolesRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + OfficePostRole + "/DeleteOfficePostRoles",
    data
  ).then((result) => {
    return result.data.data;
  });
};
